import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/api/axios-instance";

interface UserSearchResult {
  id: string;
  full_name: string | null;
  has_identifiers: boolean;
  created_at: string;
}

async function findUserByContact(
  phone?: string | null,
  email?: string | null
): Promise<string | null> {
  const search = phone ?? email;
  if (!search) return null;

  const response = await axiosInstance.get("/users", {
    params: { page: 0, search },
  });

  const users: UserSearchResult[] = response.data?.users ?? [];
  if (users.length === 0) return null;

  // Prefer user with identifiers, then newest created_at
  const sorted = [...users].sort((a, b) => {
    if (a.has_identifiers !== b.has_identifiers) return a.has_identifiers ? -1 : 1;
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  return sorted[0].id;
}

export function useFindUserByContact(
  phone?: string | null,
  email?: string | null
) {
  return useQuery({
    queryKey: ["user-by-contact", phone, email],
    queryFn: () => findUserByContact(phone, email),
    enabled: !!(phone || email),
    staleTime: 1000 * 60 * 5,
  });
}
